import { isDefinedString, reduce } from "et3-type-guards";

export const getClientReadableText = (text: string) => {
  const setLowerCase = text.toLowerCase();
  const splitUsingUnderscoreArray = setLowerCase.split("_");
  const upperCaseForFirstLetterArray = splitUsingUnderscoreArray.map(
    (text: string) => {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  );
  return upperCaseForFirstLetterArray.join(" ");
};

export const getSilentBanActionText = (extraData: string) => {
  try {
    const parsedData: { silentBanAction: string } = JSON.parse(extraData);
    const silentBanAction = reduce(() => parsedData.silentBanAction, "");
    return isDefinedString(silentBanAction) ? silentBanAction : "";
  } catch {
    return "";
  }
};

export const getFormattedTBWExtraDataArray = (extraData: string) => {
  try {
    const parsedData: string[] = JSON.parse(extraData);
    return parsedData.map((item) => item.trim()).join(", ");
  } catch {
    return "";
  }
};
